import gql from 'graphql-tag';

import { CHANGE_EVENT_FRAGMENT } from './changeEvent';

export const NOTIFICATION_ACTIVITY_FRAGMENT = gql`
  fragment notificationActivity on NotificationActivity {
    id
    isRead
    event {
      ...changeEvent
    }
    deleted
  }
  ${CHANGE_EVENT_FRAGMENT}
`;
